import { useRef, type PropsWithChildren, type ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export function Tooltip({
  anchorId,
  className,
  title,
  children,
  onShow,
  onHide,
}: PropsWithChildren<{
  anchorId: string;
  title?: ReactNode;
  className?: string;
  onShow?: () => void;
  onHide?: () => void;
}>) {
  const popover = useRef<HTMLDivElement>(null);

  function mouseEnter() {
    onShow?.();
    popover.current?.showPopover();
  }

  function mouseLeave() {
    onHide?.();
    popover.current?.hidePopover();
  }

  return (
    <>
      <div className="contents" onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}>
        {children}
      </div>
      <div
        ref={popover}
        popover="hint"
        className={twMerge("absolute mb-2 rounded-sm bg-white p-2 font-hint shadow-md [position-area:top]", className)}
        style={{ positionAnchor: `--${anchorId}` }}
      >
        {title}
      </div>
    </>
  );
}
